export default __webpack_public_path__ + "static/media/csv.cc3a181f.svg";